// extracted by mini-css-extract-plugin
export default {"riskDashboardContainer":"Risk_riskDashboardContainer__t2aG2","risk-item":"Risk_risk-item__VO7QF","text-danger":"Risk_text-danger__v9ino"};